import { mapToBreakpoints } from './mapToBreakpoints.js';
import { rem } from './rem.js';

const getWidthStyle = values => {
  return mapToBreakpoints(values, value => {
    if (typeof value === 'string') return `max-width: ${values};`;
    if (value > 1) {
      return `
        max-width: ${rem(value)};
      `;
    } else {
      const pct = Math.round((value || 1) * 100 * 10000) / 10000;
      return `
        max-width: ${pct}%;
      `;
    }
  });
};

export { getWidthStyle };
//# sourceMappingURL=getWidthStyle.js.map
